import BaseObject from './BaseObject'

class Inventory extends BaseObject {
  static _primaryKey = 'inventory_id'
  static _apiBaseRoute = 'inventory'
  static _objectType = 'inventory'
  static _isExportable = true
  static _propConfigs = [
    {
      property_name: 'inventory_id'
    },
    {
      property_name: 'ent_dilution',
      data_type: 'integer',
      validate: ['integer'],
      default: 0
    },
    {
      property_name: 'barcode'
    },
    {
      property_name: 'current_volume_ml',
      validate: ['required']
    },
    {
      property_name: 'out_date',
      validate: ['required']
    },
    {
      property_name: 'discard_date',
      validate: 'required'
    },
    {
      property_name: 'lot_number',
      validate: ['required']
    },
    {
      property_name: 'product',
      relation_class: null,
      relation_class_loader: async function() {
        return await import('./Product')
      },
      relation_type: BaseObject._relationTypes.hasOne,
      validate: 'required'
    },
    // {
    //   property_name: 'ent_concentrate_inventory',
    //   relation_class: null,
    //   relation_class_loader: async function () {
    //     return await import('./Inventory')
    //   },
    //   relation_type: BaseObject._relationTypes.hasOne
    // },
    {
      property_name: 'ent_dilution_type',
      relation_class: null,
      relation_class_loader: async function() {
        return await import('./ENTDilutionType')
      },
      relation_type: BaseObject._relationTypes.hasMany
    },
    // {
    //   property_name: 'custom_compound_log',
    //   relation_class: null,
    //   relation_class_loader: async function () {
    //     return await import('./CustomCompoundLot')
    //   },
    //   relation_type: BaseObject._relationTypes.hasOne
    // },
    {
      property_name: 'location',
      relation_class: null,
      relation_class_loader: async function() {
        return await import('./InventoryLocation')
      },
      relation_type: BaseObject._relationTypes.hasOne,
      validate: 'required'
    }
  ]
  constructor(row = {}, prefix = '', hasManyPostfix = null) {
    super(row)
    this.prefix = prefix
    this.hasManyPostfix = hasManyPostfix
    if (Object.keys(row).length > 0) {
      this._propConfigs.forEach(propName =>
        this._addPropIfExists(propName, row)
      )
    }
  }
  get optionName() {
    return `${this[this._primaryKey]}: ${this.lot_number} - ${this.barcode}`
  }
  isEquivalent = inventory => {
    return (
      (this.product == null || this.product.mapped_id == inventory.product.product_id) &&
      (this.ent_dilution == null || this.ent_dilution == inventory.ent_dilution) &&
      (this.ent_dilution_type == null || inventory.ent_dilution_type == null || this.ent_dilution_type.mapped_id == inventory.ent_dilution_type.dilution_type_id) &&
      (this.out_date == null || this.out_date == inventory.out_date) &&
      (this.discard_date == null || this.discard_date == inventory.discard_date) &&
      (this.lot_number == inventory.lot_number) &&
      (this.location == null || inventory.location == null || this.location.mapped_id == inventory.location.inventory_location_id)
    )
  }
  flagForImport = () => {
    // only ent_dilution = 0 is importable.
    // returning -2 flags the item instance as "skip import"
    return this.ent_dilution == 0 ? -1 : -2
  }
  buildImportableItem = () => {
    const importable = this._clean()
    // location
    if (this.location?.mapped_id != null && this.location.mapped_id != -1) {
      importable.location = { inventory_location_id: this.location.mapped_id }
    }
    // ent_dilution_type
    if (this.ent_dilution_type?.mapped_id != null && this.ent_dilution_type.mapped_id != -1) {
      importable.ent_dilution_type = { ent_dilution_type_id: this.ent_dilution_type.mapped_id }
    }
    // product
    importable.product = { product_id: this.product.mapped_id }
    return importable
  }
}

export default Inventory
